import React from 'react';
import styled from 'styled-components';

import { Container } from 'ui/components/styled';
import { IconButton } from 'ui/components/shared';

const DefaultColor = '#3591fc';

export const ViewSwitcher = ({ active, onChange, disabled, color = DefaultColor }) => {
  const [activeView, setActiveView] = React.useState(active);

  const setView = (view) => {
    setActiveView(view);
    if (onChange) {
      onChange(view);
    }
  };

  return (
    <Container flexDirection="row" alignItems="inherit" width="auto" mr="m">
      <StyledIconButton
        icon={ListSvg}
        color={color}
        isActive={activeView === 'list'}
        onClick={() => setView('list')}
        disabled={disabled === 'list'}
      />
      <StyledIconButton
        icon={TableSvg}
        color={color}
        isActive={activeView === 'table'}
        placement="right"
        onClick={() => setView('table')}
        disabled={disabled === 'table'}
      />
    </Container>
  );
};

const ToggleableIconButton = ({ icon: Icon, isActive, placement, color, ...rest }) => {
  return (
    <IconButton
      icon={() => <Icon color={isActive ? '#fff' : color} />}
      bg={isActive ? color : 'transparent'}
      borderRadius={placement === 'right' ? '0 2px 2px 0' : '2px 0 0 2px'}
      {...rest}
    />
  );
};

const StyledIconButton = styled(ToggleableIconButton)`
  border: 1px solid ${({ color }) => color};
  ${({ placement }) => {
    switch (placement) {
      case 'right':
        return `
          border-left: none;
        `;
      default:
        return `
          border-right: none;
        `;
    }
  }}
`;

const TableSvg = ({ color = DefaultColor, width = '20px' }) => {
  return (
    <svg
      id="table"
      xmlns="http://www.w3.org/2000/svg"
      width="22.203"
      height="18.655"
      viewBox="0 0 22.203 18.655"
      style={{
        width,
      }}
    >
      <g id="Groupe_32" data-name="Groupe 32">
        <path
          id="Tracé_4"
          data-name="Tracé 4"
          d="M21.237,0H.965A.9.9,0,0,0,0,.811V17.843a.9.9,0,0,0,.965.811H21.237a.9.9,0,0,0,.965-.811V.811A.9.9,0,0,0,21.237,0ZM7.723,12.977V8.922H14.48v4.055Zm6.757.811v4.055H7.723V13.788Zm0-9.733V8.111H7.723V4.055Zm6.757,0V8.111H15.445V4.055ZM6.757,8.111H.965V4.055H6.757ZM.965,8.922H6.757v4.055H.965Zm14.48,0h5.792v4.055H15.445ZM21.237.811V3.244H.965V.811ZM.965,13.788H6.757v4.055H.965Zm14.48,4.055V13.788h5.792v4.055Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

const ListSvg = ({ color = DefaultColor, width = '20px' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22.905"
      height="16"
      viewBox="0 0 22.905 16"
      style={{
        width,
      }}
    >
      <g id="list" transform="translate(0 -79)">
        <g id="Groupe_19" data-name="Groupe 19" transform="translate(5.559 86.024)">
          <g id="Groupe_18" data-name="Groupe 18">
            <path
              id="Tracé_1"
              data-name="Tracé 1"
              d="M140.713,236H125.157a.895.895,0,1,0,0,1.789h15.556a.895.895,0,1,0,0-1.789Z"
              transform="translate(-124.262 -236)"
              fill={color}
            />
          </g>
        </g>
        <g id="Groupe_21" data-name="Groupe 21" transform="translate(5.559 79.313)">
          <g id="Groupe_20" data-name="Groupe 20">
            <path
              id="Tracé_2"
              data-name="Tracé 2"
              d="M140.713,86H125.157a.895.895,0,1,0,0,1.789h15.556a.895.895,0,1,0,0-1.789Z"
              transform="translate(-124.262 -86)"
              fill={color}
            />
          </g>
        </g>
        <g id="Groupe_23" data-name="Groupe 23" transform="translate(5.559 92.734)">
          <g id="Groupe_22" data-name="Groupe 22">
            <path
              id="Tracé_3"
              data-name="Tracé 3"
              d="M140.713,386H125.157a.895.895,0,1,0,0,1.789h15.556a.895.895,0,1,0,0-1.789Z"
              transform="translate(-124.262 -386)"
              fill={color}
            />
          </g>
        </g>
        <g id="Groupe_25" data-name="Groupe 25" transform="translate(0 79)">
          <g id="Groupe_24" data-name="Groupe 24">
            <circle id="Ellipse_11" data-name="Ellipse 11" cx="1" cy="1" r="1" fill={color} />
          </g>
        </g>
        <g id="Groupe_27" data-name="Groupe 27" transform="translate(0 85.843)">
          <g id="Groupe_26" data-name="Groupe 26" transform="translate(0 0)">
            <circle
              id="Ellipse_12"
              data-name="Ellipse 12"
              cx="1"
              cy="1"
              r="1"
              transform="translate(0 0.157)"
              fill={color}
            />
          </g>
        </g>
        <g id="Groupe_29" data-name="Groupe 29" transform="translate(0 92.686)">
          <g id="Groupe_28" data-name="Groupe 28" transform="translate(0 0)">
            <circle
              id="Ellipse_13"
              data-name="Ellipse 13"
              cx="1"
              cy="1"
              r="1"
              transform="translate(0 0.314)"
              fill={color}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
